import { render, staticRenderFns } from "./BudgetItemCard.vue?vue&type=template&id=40c194ea&scoped=true"
import script from "./BudgetItemCard.vue?vue&type=script&lang=js"
export * from "./BudgetItemCard.vue?vue&type=script&lang=js"
import style0 from "./BudgetItemCard.vue?vue&type=style&index=0&id=40c194ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c194ea",
  null
  
)

export default component.exports